<template>
  <div class="pdf-view">
    <image-toolbox :selectedNum="selectedPDF.length" :loadedAllImageNum="pdfs.length" :selectedImages="selectedPDF" :mode="'pdf'"
    v-on:closeSelected="closeSelected"
    v-on:deleteSelectedImages="deleteSelectedImages"
    v-on:selectLoaded="selectLoadedImage"></image-toolbox>
    <div class="view-content pdf-view-content clearfix">
      <div class="fixed-line clearfix" v-if="pdfs.length !== 0">
        <div class="fixed-left">
          <div class="checkbox" :class="{'selected': selectedNum == pdfs.length && pdfs.length != 0}" @click="selectedAll(selectedNum != pdfs.length)"></div>
        </div>
        <div class="total-item">{{$t('list.total')}} {{pdfs.length}} {{$t('list.items')}}</div>
      </div>
      <div class="view-item pdf-item" :class="{'selected': pdf.selected}" v-for="(pdf, pdfIndex) in pdfs" :key="pdfIndex">
        <div class="pdf-item-a" @click.stop="pdfView(pdfIndex)" :title="pdf.fileName">
          <img class="img-pdf" src="../../assets/images/pdf.png" alt="">
          <div class="view-item-t">{{pdf.fileName}}</div>
          <div class="checkbox" @click.stop="singlePdfCheck(pdfIndex)"></div>
        </div>
      </div>
      <!-- 没有文件 -->
      <div class="no-file" v-if="pdfs.length === 0 && inited">
        <div class="no-file-main">
          <img src="../../assets/images/no_file.png" alt="">
          <div>{{$t('list.noFile')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
import ImageToolbox from './ImageToolbox'
import Pdf from 'common/model/Pdf'
export default {
  name: 'pdfView',
  components: {
    ImageToolbox
  },
  data () {
    return {
      pdfs: [],
      inited: false
    }
  },
  created () {
    var obj = this
    setTimeout(function () {
      obj.requestPdfList()
    }, 100)
  },
  computed: {
    selectedPDF () {
      var selectedPDF = []
      for (var i = 0; i < this.pdfs.length; i++) {
        if (this.pdfs[i].selected) {
          selectedPDF.push(this.pdfs[i])
        }
      }
      return selectedPDF
    },
    selectedNum () {
      return this.selectedPDF.length
    }
  },
  methods: {
    selectedAll: function (selected) {
      for (var k = 0; k < this.pdfs.length; k++) {
        this.pdfs[k].selected = selected
      }
    },
    singlePdfCheck: function (index) {
      this.pdfs[index].selected = !this.pdfs[index].selected
    },
    pdfView: function (index) {
      if (this.selectedNum > 0) {
        this.singlePdfCheck(index)
      } else {
        var pdfHref = ''
        pdfHref = this.pdfs[index].url
        window.open(pdfHref, '_blank')
      }
    },
    requestPdfList: function () {
      HttpClient.getData(Config.APP_HOST + '/v2/pdf/time?u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID), this).then((response) => {
        this.inited = true
        if (response.code === Config.R_CODE.SUCCESS) {
          // console.log(response.body)
          for (var i = 0; i < response.body.length; i++) {
            var pdf = new Pdf()
            pdf.loadData(response.body[i])
            this.pdfs.push(pdf)
          }
        }
      })
    },
    closeSelected: function () {
      this.selectedAll(false)
    },
    deleteSelectedImages: function () {
      for (var j = 0; j < this.pdfs.length; j++) {
        if (this.pdfs[j].selected) {
          this.pdfs.splice(j, 1)
          j--
        }
      }
    },
    selectLoadedImage: function () {
      this.selectedAll(true)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.pdf-view-content
  padding 90px 0 50px 30px
  &:hover
    .fixed-left
      .checkbox
        display block
  .fixed-left
    .checkbox
      top 10px
      &.selected
        display block
        background-image url('../../assets/images/checkbox_click.png')
  .pdf-item
    cursor pointer
    &:hover
      .pdf-item-a
        top -8px
        box-shadow rgba(169, 169, 169, 0.64) 0px 6px 30px 5px
      .checkbox
        display block
    &.selected
      .pdf-item-a
        .checkbox
          display block
          background-image url('../../assets/images/checkbox_click.png')
    .pdf-item-a
      display block
      width 100%
      height 100%
      position absolute
      top 0
      left 0
      background-color #fff
      border-radius 4px
      transition all .3s ease
      .img-pdf
        position absolute
        top 0
        left 0
        right 0
        bottom 0
        margin auto
      .view-item-t
        display inline-block
        max-width 130px
        height 12px
        line-height 12px
        white-space nowrap
        text-overflow ellipsis
        overflow hidden
      .checkbox
        bottom 10px
        right 12px
</style>



// WEBPACK FOOTER //
// src/components/Et/PdfView.vue